import { render, staticRenderFns } from "./bgItem.vue?vue&type=template&id=170331f9&scoped=true"
import script from "./bgItem.vue?vue&type=script&lang=js"
export * from "./bgItem.vue?vue&type=script&lang=js"
import style0 from "./bgItem.vue?vue&type=style&index=0&id=170331f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170331f9",
  null
  
)

export default component.exports